module.exports = __webpack_public_path__ + "img/02-Kleinwagen.72a13ce8.svg";